export default "__VITE_ASSET__BxAH7RBD__"